import React, { FC, useEffect, useState } from "react"
import { ProfileConfirmationForm } from "./profile-confirmation-form"
import { ProfileConfirmation } from 'appDtos';
import { readProfileConfirmation, submitProfileConfirmation } from "../../../common/api/products"
import { LoadingIndicator, Sizes, toast, ToastType } from "@chr/navisphereonline-shared-components";
import { useParams, useLocation } from "react-router-dom";
import { ProfileConfirmationEmailSent } from "./profile-confirmation-email-sent";

declare type urlParam = {
  guid: string,
}

const ProfileConfirmationFormWrapper: FC = () => {
  const { guid } = useParams() as urlParam;
  const urlSearchParams = new URLSearchParams(useLocation().search);
  const [ profile, setProfile ] = useState<ProfileConfirmation>();
  const [ isLoading, setIsloading ] = useState(true);
  const [ isSaved, setIsSaved ] = useState(false);

  const onClose = () => {
    const iframeOrigin = urlSearchParams.get("iframeorigin");
    if(iframeOrigin){
      window.parent.postMessage( 'CLOSE_MODAL', iframeOrigin );
    } else {
      window.location.replace('/#')
    }
  };

  const errorMessage = (errorCode:any) => (<>
    <span data-testid="error-message">There was a problem and we were unable to send your confirmation email. Please try again. If
      the problem continues, please contact your C.H. Robinson representative.</span>
    {errorCode
      ? <div>{'Error Code: ' + errorCode}</div>
      : null}
  </>);

  const onEdit = () => setIsSaved(false);

  const onSubmit = (profile:ProfileConfirmation) => {
    setIsloading(true);
    setProfile(profile);

    submitProfileConfirmation(profile)
      .then(() => {
        setIsSaved(true);
      }).catch((ex) => {
        const statusCode = ex.response && ex.response.status;
        toast(errorMessage(statusCode), ToastType.error);
      }).finally(() =>
        setIsloading(false)
      );
  };

  useEffect(() => {
    function escKeyPressHandler(event: KeyboardEvent) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        onClose();
      }
    }

    window.addEventListener('keydown', escKeyPressHandler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function getProfile(guid:string) {
      try{
        const response = await readProfileConfirmation(guid);
        if(response) {
          setProfile(response);
        }
      } catch {
        console.error('No profile found');
      } finally {
        setIsloading(false);
      }
    }

    if(guid) {
      getProfile(guid);
    }
  }, [guid]);


  if(isLoading){
    return (
      <div className="container profile-confirmation" data-testid="loading-spinner">
        <LoadingIndicator size={Sizes.Large} />
      </div>);

  } else if(isSaved && profile){
    return <ProfileConfirmationEmailSent profileConfirmationId={profile.profileConfirmationId} email={profile.email} onClose={onClose} onEdit={onEdit}/>

  } else if(profile){
    return <ProfileConfirmationForm profile={profile} onClose={onClose} onSubmit={onSubmit}/>

  } else {
    onClose();
    return null
  }
}

export default ProfileConfirmationFormWrapper;
